import { computed } from 'vue';
import { useProjectSchemaStore } from '~/stores/project-schema';

export function useFileCollection() {
	const { findCollectionByName, findPrimitiveFieldByName, findSingleRelationFieldByName } = useProjectSchemaStore();

	const collection = computed(() => findCollectionByName('MonospaceFile'));

	const titleField = computed(() => {
		if (!collection.value) return;
		return findPrimitiveFieldByName(collection.value, 'fileName');
	});

	const thumbnailField = computed(() => {
		if (!collection.value) return;
		return findSingleRelationFieldByName(collection.value, '$thumbnail');
	});

	const filesizeField = computed(() => {
		if (!collection.value) return;
		return findPrimitiveFieldByName(collection.value, 'fileSize');
	});

	const mediaTypeField = computed(() => {
		if (!collection.value) return;
		return findPrimitiveFieldByName(collection.value, 'mediaType');
	});

	return {
		collection,
		titleField,
		thumbnailField,
		filesizeField,
		mediaTypeField,
	};
}
